import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuardService implements CanActivate {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    let url = route.data['url'];
    const botId = !!route.data['botIdFrom'] ? (route.queryParams || {})[route.data['botIdFrom']] : (route.params || {}).botId;
    if (route.data['appendBotId'] && !!botId) url += `/${botId}`;
    const queries = route.data['ignoreQueries']
      ? ''
      : Object.keys(route.queryParams || {})
          .map(key => `${key}=${route.queryParams[key]}`)
          .join('&');
    window.location.href = url + (queries ? '?' : '') + queries;
    return false;
  }
}
